import { Loading } from "@/App";
import { useAuth0 } from "@/Contexts";

import { useEffect } from "react";

import { usePostHog } from "posthog-js/react";

export const Logout = () => {
  const { logout } = useAuth0()!;
  const posthog = usePostHog();

  useEffect(() => {
    posthog.reset();

    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  }, [logout, posthog]);

  return <Loading />;
};
